<template>
  <div
    :class="$style.container"
    id="loading"
    v-loading.fullscreen.lock.body="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div style="overflow: hidden;">
      <el-col style="padding-right: 20px;margin-top: 15px ;">
        <el-calendar :first-day-of-week="7" v-model="calendarDate">
          <template slot="dateCell" slot-scope="{ data }">
            <div>
              {{
                data.day
                  .split("-")
                  .slice(2)
                  .join("-")
              }}<br />
              <!-- datademo[1.2.3.1.5.6].sales_day -->
              <!-- <span style="color:red;">{{ my_date(data.day) }} {{ datademo[data.day] }}</span> -->
              <div style="display:flex;justify-content: center;align-items: center;padding-top: 10px;">
                <div v-if="data.type == 'current-month'" style="padding-right:5px">开启设定</div>
                <div v-for="(item, index) of datademo" :key="index">
                  <el-switch
                    style="display: flex;"
                    @change="switchday(item)"
                    v-model="datademo[index].sales_day"
                    active-color="#13ce66"
                    inactive-color="#D5D5D5"
                    v-if="
                      data.type == 'current-month' &&
                        index + 1 ==
                          data.day
                            .split('-')
                            .slice(2)
                            .join('-')
                    "
                  >
                  </el-switch>
                </div>
              </div>
            </div>
          </template>
        </el-calendar>
      </el-col>
    </div>
  </div>
</template>
<script>
import "swiper/css/swiper.min.css";
import "swiper/js/swiper.min.js";
import http from "../../APIService/http";
// import moment from "moment";
//  "isSelected": true, "type": "current-month", "day": "2022-12-07"
let moment = require("moment");
export default {
  name: "calendar",
  data() {
    return {
      datademo: [],
      calendarDate: moment().format("YYYY-MM-DD"),
      calendY: "",
      calendYM: "",
    };
  },

  mounted() {
    this.calendY = moment().format("YYYY");
    this.calendYM = moment().format("YYYYMM");
    this.getSalesDays();
  },
  watch: {
    calendarDate(val, oldVal) {
      if (val && moment(val).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD")) {
        // console.log("点击了‘今天’按钮");
        this.calendY = moment(val).format("YYYY");
        this.calendYM = moment(val).format("YYYYMM");
      } else if (
        val &&
        moment(val).toDate() <
          moment(oldVal)
            .startOf("month")
            .toDate()
      ) {
        // console.log("点击了‘上个月’按钮");
        this.calendY = moment(val).format("YYYY");
        this.calendYM = moment(val).format("YYYYMM");
      } else if (
        val &&
        moment(val).toDate() >
          moment(oldVal)
            .endOf("month")
            .toDate()
      ) {
        // console.log("点击了‘下个月’按钮");
        this.calendY = moment(val).format("YYYY");
        this.calendYM = moment(val).format("YYYYMM");
      } else {
      }
      this.getSalesDays();
    },
  },
  methods: {
    switchday(item) {
      this.setSalesDays(item);
    },
    async getSalesDays() {
      try {
        debugger;
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          working_year: this.calendY,
          working_month: this.calendYM,
        };
        debugger;
        await http.post("/crm/activity/sales/getSalesDays", data).then((res) => {
          if (res.success) {
            let array = res.data;
            this.judeg(array);
            loading.close();
          }
        });
      } catch (e) {
        console.log(e);
      }
    },

    async setSalesDays(item) {
      try {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          working_day: item.working_day,
          sales_day: item.sales_day ? "T" : "F",
        };

        await http.post("/crm/activity/sales/setSalesDays", data).then((res) => {
          if (res.success) {
              this.getSalesDays();
          }
        });
      } catch (e) {
        console.log(e);
      }
    },

    judeg(arr) {
      this.datademo = [];
      arr.forEach((item) => {
        let it = [];
        it.working_day = item.working_day;
        it.sales_day = item.sales_day == "T" ? true : false;
        this.datademo.push(it);
      });
    },
  },
};
</script>
<style></style>

<style lang="scss" module>
.container {
  background: white;
  height: 1000%;
}
</style>
<style scoped></style>
<style>
#calendar .el-tabs__nav-scroll {
  position: relative;
  height: 50px;
}
#calendar .el-calendar-day {
  position: relative;
  height: 50px;
  width: 50px;
}
#calendar .el-tabs__nav {
  display: block;
  position: absolute;
  border: 1px solid transparent;
  left: 50%;
  margin-left: -174px;
}
#calendar .el-tabs__header {
  border-bottom: none;
}
#calendar .el-tabs__item {
  border: 1px solid #dcdfe6;
  padding-left: 50px;
  padding-right: 50px;
  font-size: 18px;
}
#calendar .is-active {
  color: #409eff;
  border: 1px solid #c6e2ff;
  background-color: #ecf5ff;
}
#calendar .el-tabs__item:first-child {
  border-radius: 4px 0 0 4px;
}
.amap-lib-marker-mid {
  display: none;
}
.amap-lib-marker-from {
  display: none;
}
.amap-lib-marker-to {
  display: none;
}
#calendar .el-tabs__item:nth-of-type(2) {
  border-left: none;
  border-right: none;
}
#calendar .el-tabs__item:last-child {
  border-radius: 0px 4px 4px 0px;
}
#calendar td {
  border: none;
}
#calendar .el-calendar-table .el-calendar-day {
  text-align: center;
  height: 40px;
}
#calendar .el-calendar {
  border: 1px solid #dcdfe6;
}
#calendar .el-calendar__header {
  padding-bottom: 0;
  border-bottom: none;
}
#calendar_body_row_p .el-tabs__content {
  height: calc(100% - 65px);
}
#calendar #calendar_body_row_p p {
  margin-top: 12px;
  margin-bottom: 12px;
}
#calendar .el-button.el-button--plain.el-button--mini {
  padding: 4px 5px;
  font-size: 12px;
}
#calendar .el-calendar__title {
  font-weight: bold;
}
#calendar h4 {
  border-bottom: none;
  margin-bottom: 0;
}
#calendar_weekPlanInfo_dialog .el-dialog__body {
  padding: 15px 20px 20px;
}
</style>
<style rel="stylesheet/scss" scoped lang="scss">
#calendar #calendarColDay:hover {
  cursor: pointer;
}
#calendar .calendar {
  width: 100%;
  margin: 0px 0px 20px 0px;
  color: #555;
  position: relative;
}

#calendar .calendar h4 {
  line-height: 40px;
  background-color: #fff;
  text-align: center;
  color: #333;
  box-shadow: 0 0 4px #bbb;
  -webkit-box-shadow: 0 0 4px #bbb;
}

#calendar .calendar button {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 5px;
  color: #777;
  background: #f3f3f3;
  border: none;
}

#calendar .calendar button:focus {
  border: none;
  outline: none;
}

#calendar .calendar button.month-less {
  left: 10px;
}

#calendar .calendar button.month-add {
  right: 10px;
}

#calendar .calendar .sign_tab {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e8e8e8;
  border-top: 0;
  table-layout: fixed;
}

#calendar .calendar .sign_tab th {
  text-align: center;
  height: 14.28571428571429vw;
  font-weight: 700;
}

#calendar .calendar .sign_tab td {
  position: relative;
  border: 1px solid #eee;
  padding: 15px 0;
  text-align: center;
  font-size: 14px;
  font-family: arial;
}

#calendar .calendar .sign_tab td.over {
  background-color: #fff;
  border-left: 0;
  border-right: 0;
}

#calendar .calendar .sign_tab td.disa {
  color: #ccc;
  background: none;
  height: 50px;
  * {
    color: #ccc;
    right: 10px;
    top: 10px;
  }
}
#calendar .calendar .styleNowDate {
  display: inline-block;
  padding: 5px;
  border-radius: 50%;
  background: red;
  color: white;
}

#calendar .calendar .sign_tab td.other {
  height: 50px;
  cursor: pointer;
  color: #646464;
}

#calendar .calendar .sign_tab td.check_day {
  background-color: #f8f8f8;
  color: #58ce7a;
  position: relative;
}

#calendar .calendar {
  .ui-state-down,
  .ui-state-default {
    font-size: 10px;
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 3px;
    left: 0;
  }
  .ui-state-down {
    color: #f60;
  }
}

#calendar .calendar .ui-state-up {
  font-size: 10px;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 3px;
  left: 0;
}

#calendar .calendar .sign_tab td.cur_day {
  background-color: #ffd2d2;
  color: #fff;
}

#calendar .checkin-btn {
  display: block;
  width: 90%;
  margin: 0 auto;
  text-align: center;
  font-size: 10px;
}
#calendar .weekLi {
  border: 1px solid #dcdfe6;
}
#calendar .weekLi:first-child {
  position: absolute;
  left: -20%;
  border-right: none;
}
#calendar .weekLi:nth-child(2) {
  position: absolute;
  left: 0%;
  border-right: none;
}
#calendar .weekLi:nth-child(3) {
  position: absolute;
  left: 20%;
  border-right: none;
}
#calendar .weekLi:nth-child(4) {
  position: absolute;
  left: 40%;
  border-right: none;
}
#calendar .weekLi:nth-child(5) {
  position: absolute;
  left: 60%;
}
#calendar .weekLi:nth-child(6) {
  position: absolute;
  left: 80%;
}
#calendar .weekLi:nth-child(7) {
  position: absolute;
  left: 100%;
  border-right: 1px solid #dcdfe6 !important;
}
#calendar ul li.border-right {
  border-right: none;
}
#calendar ul li.border {
  border-right: none;
}
#calendar ul.ulScoller {
  left: 0;
}
#calendar ul.weekLiLeft {
  left: 20%;
}

#calendar ul.weekLiRight {
  left: -20%;
}
</style>



// WEBPACK FOOTER //
// src/pages/changzhou/changzhou_set.vue